import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const Profile = () => {
  const authToken = localStorage.getItem('authToken');
  const navigate = useNavigate();

  const [profileData, setProfileData] = useState(null);
  const [editable, setEditable] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);  // State to manage menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);  // Toggle the menu visibility
  };

  useEffect(() => {
    // If there is no authToken, redirect the user to SignIn page
    if (!authToken) {
      navigate('/');
    }
  }, [authToken, navigate]);


  const handleLogout = () => {
    // Remove authToken from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('otp');
    
    // Optional: If you're using a global state (like context or redux), you may want to clear that as well
    // Example with context (if applicable):
    // dispatch({ type: 'LOGOUT' });
  
    // Redirect user to login page or home page
    window.location.href = '/';  // or use a router if you're using react-router
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch('https://beta.flowlogic.com/api/users/profile/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
          },
        });

        const result = await response.json();
        console.log(result.data);
        setProfileData(result.data); // Adjust based on API response shape
      } catch (error) {
        setErrorMessage('Failed to fetch profile data');
      }
    };

    fetchProfile();
  }, [authToken]);

  const handleInputChange = (field, value) => {
    setProfileData(prev => ({ ...prev, [field]: value }));
    console.log(profileData);
  };

  const handleUpdate = async () => {
    try {
        console.log('Updating with:', JSON.stringify(profileData, null, 2));

      const response = await fetch('https://beta.flowlogic.com/api/users/update/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify(profileData),
      });

      if (response.ok) {
        navigate('/circle-filter'); // redirect after successful update
      } else {
        const result = await response.json();
        setErrorMessage(result.error || 'Update failed.');
      }
    } catch (error) {
      setErrorMessage('An error occurred while updating.');
    }
  };

//   if (!profileData) return <p>Loading...</p>;

  if (!profileData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
    <div className="headerTop">
        {/* FlowLogic Icon */}
        <img src={"/assets/Flowlogic-Logo.svg"} alt="FlowLogic Icon"  />
        {/* Search Box - Positioned Above Both Map and List */}
        {/* <div style={{ height: '40px', position: 'relative', zIndex: 100 }}>
            <div ref={geocoderContainerRef} className="geoCodeSerach"></div>
        </div> */}
        <div className="headerRightOuter">
            <div className="headerRight">
                <div className="profilePic"><img src={"/assets/Profile-pic.png"} alt="Profile"  /></div>
                <nav className="navbar">
                    {/* Hamburger Icon */}
                    <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <div className="line line-1"></div>
                    <div className="line line-2"></div>
                    <div className="line line-3"></div>
                    </div>

                    {/* Menu Items */}
                    <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li><a href="/profile">Manage</a></li>
                        <li><a href="#">Notifications</a></li>
                        <li><a href="#" onClick={handleLogout}>Logout</a></li>
                    </ul>
                    </div>
                </nav>
            </div>
        </div>

    </div>
    {/* <div style={{ display: 'flex', flex: 1, overflow: 'hidden', backgroundColor: '#f9f9f9' }}> */}
    <div style={{  backgroundColor: '#f9f9f9' }}>

    {/* <div className="register-container"> */}
    <div className="register-container" style={{ backgroundColor: 'transparent' }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="logo">
          {/* <img src="/assets/Flowlogic-Logo.svg" alt="FlowLogic Icon" /> */}
          {/* <h4>Profile</h4> */}
        </div>
        <div>
          <Button variant="outline-secondary" onClick={() => navigate('/circle-filter')}>Go to Map</Button>
        </div>
      </div>

      {/* <h6>Profile</h6> */}
      <div className="d-flex justify-content-between align-items-center mb-4">
  <h2 style={{ fontWeight: 'bold', fontSize: '2rem' }}>Profile</h2>
  </div>
      {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

      <form onSubmit={(e) => { e.preventDefault(); editable && handleUpdate(); }}>
        <div className="form-group">
          <label>First Name:</label>
          <input
            type="text"
            value={profileData.first_name}
            onChange={(e) => handleInputChange('first_name', e.target.value)}
            disabled={!editable}
            required
          />
        </div>

        <div className="form-group">
          <label>Last Name:</label>
          <input
            type="text"
            value={profileData.last_name}
            onChange={(e) => handleInputChange('last_name', e.target.value)}
            disabled={!editable}
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number:</label>
          <input
            type="text"
            value={profileData.phone_number}
            onChange={(e) => handleInputChange('phone_number', e.target.value.replace(/\D/g, '').slice(0, 10))}
            maxLength={10}
            disabled={!editable}
            required
          />
        </div>

        {/* <div className="form-group">
          <label>Country Code:</label>
          <input
            type="text"
            value={profileData.country_code}
            onChange={(e) => handleInputChange('country_code', e.target.value)}
            disabled={!editable}
            required
          />
        </div> */}

        <div className="form-group">
          <label>Investment Profile:</label>
          <select
            value={profileData.inv_type} 
            onChange={(e) => handleInputChange('invest_type', e.target.value)}
            disabled={!editable}
            className="form-control"
          >
            <option value="">Select Investment Type</option>
            <option value="individual">Individual</option>
            <option value="re_agent">Real Estate Agent</option>
            <option value="analyst">Analyst</option>
            <option value="inv_firm">Investment Firm</option>
            <option value="prop_manager">Property Manager</option>
          </select>
        </div>

        <div className="form-group">
          <label>Investment Experience:</label>
          <select
            value={profileData.inv_exp}
            onChange={(e) => handleInputChange('invest_exp', e.target.value)}
            disabled={!editable}
            className="form-control"
          >
            <option value="">Select Investment Experience</option>
            <option value="new">New</option>
            <option value="below3">Below 3 years</option>
            <option value="below5">Below 5 years</option>
            <option value="above5">Above 5 years</option>
          </select>
        </div>

        {/* {editable ? (
          <button type="submit" className="btn btn-success">Confirm Edit</button>
        ) : (
          <Button variant="primary" onClick={() => setEditable(true)}>Edit Profile</Button>
        )} */}

          <button type="submit" className="btn btn-success">Update</button>
      
      </form>
    </div>
    </div>
    </div>
  );
};

export default Profile;
